import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

const { mediaQuery, opacity } = baseVariables;

export const StyledImageBanner = styled.div`
  position: relative;
  overflow: hidden;

  img {
    width: 100%;
  }

  .caption {
    background-color: rgba(28, 28, 28, ${opacity['opacity5']});
    border-radius: ${toRem(5)};
    padding: ${toRem(3)} ${toRem(8)};
    position: absolute;
    top: ${toRem(12)};
    right: ${toRem(12)};

    .t-label-inverse-xs {
      display: flex;
      align-items: center;
    }

    @media ${mediaQuery.lg} {
      top: ${toRem(20)};
      right: ${toRem(20)};
    }
  }
`;
